// **Formulare der Vorlagen ↔ Rümpfe für die Instanz** — rein, getestet
// (templates-map.test.ts). Zweisprachig wie in der Instanz (Deutsch/Englisch,
// eine Sprache genügt); der Prompt selbst wird nicht übersetzt.

import type { Localized, PromptTemplate, TemplateCategory } from "../../api/types";

export const TEMPLATE_ERRORS: Record<string, string> = {
  invalid_title: "Ein Titel ist Pflicht (Deutsch oder Englisch).",
  invalid_name: "Ein Name ist Pflicht (Deutsch oder Englisch).",
  invalid_prompt: "Der Prompt darf nicht leer sein.",
  invalid_category: "Bitte eine Kategorie wählen.",
  category_in_use: "Die Kategorie enthält noch Vorlagen.",
};

/** Deutsch, sonst Englisch, sonst leer. */
export const txt = (o: Localized | null | undefined): string => o?.de || o?.en || "";

const lines = (s: string) => s.split("\n").map((x) => x.trim()).filter(Boolean);

export interface CategoryState {
  name_de: string;
  name_en: string;
  position: string;
}

/** Eine neue Kategorie kommt hinter die letzte (Position + 10). */
export function categoryFrom(c: TemplateCategory | null, all: TemplateCategory[]): CategoryState {
  if (!c) return { name_de: "", name_en: "", position: String((all.at(-1)?.position ?? 0) + 10) };
  return { name_de: c.name.de ?? "", name_en: c.name.en ?? "", position: String(c.position) };
}

export function categoryBody(s: CategoryState) {
  return { name: { de: s.name_de.trim(), en: s.name_en.trim() }, position: Number(s.position.trim() || 0) };
}

export interface TemplateState {
  category_id: string;
  position: string;
  title_de: string;
  title_en: string;
  desc_de: string;
  desc_en: string;
  deps_de: string;
  deps_en: string;
  prompt: string;
  featured: boolean;
}

/** Eine neue Vorlage startet in der ersten Kategorie. */
export function templateFrom(t: PromptTemplate | null, categories: TemplateCategory[]): TemplateState {
  const ids = categories.map((c) => String(c.id));
  const cat = t ? String(t.category_id) : (ids[0] ?? "");
  return {
    // Wie ein natives Auswahlfeld: eine Kategorie, die es nicht mehr gibt, wird die erste.
    category_id: ids.includes(cat) ? cat : (ids[0] ?? ""),
    position: String(t?.position ?? 0),
    title_de: t?.title.de ?? "",
    title_en: t?.title.en ?? "",
    desc_de: t?.description.de ?? "",
    desc_en: t?.description.en ?? "",
    deps_de: (t?.dependencies.de ?? []).join("\n"),
    deps_en: (t?.dependencies.en ?? []).join("\n"),
    prompt: t?.prompt ?? "",
    featured: t?.featured ?? false,
  };
}

export function templateBody(s: TemplateState) {
  return {
    category_id: Number(s.category_id),
    position: Number(s.position || 0),
    title: { de: s.title_de.trim(), en: s.title_en.trim() },
    description: { de: s.desc_de.trim(), en: s.desc_en.trim() },
    dependencies: { de: lines(s.deps_de), en: lines(s.deps_en) },
    prompt: s.prompt,
    featured: s.featured,
  };
}
